import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ThemeLogo from './ThemeLogo';

export default function ChangePassword() {
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ background: 'linear-gradient(135deg, var(--primary-500) 0%, var(--cyan-400) 50%, var(--primary-600) 100%)', minHeight: '100vh', padding: 0, position: 'relative' }}>
      <span
        onClick={() => navigate('/')}
        style={{
          position: 'absolute',
          top: 18,
          right: 24,
          fontSize: 22,
          color: '#888',
          cursor: 'pointer',
          zIndex: 10,
          fontWeight: 400,
          lineHeight: 1,
          transition: 'color 0.2s',
        }}
        aria-label="Close change password"
        title="Close"
      >
        &times;
      </span>
      <Container fluid style={{ maxWidth: 1100, margin: '0 auto', padding: '0' }}>
        {/* Logo and Logout */}
        <Row className="align-items-center mb-4" style={{ paddingTop: 32 }}>
          <Col xs="auto">
            <ThemeLogo style={{ width: 100, height: 100, marginRight: 12 }} alt="Logo" />
            <span style={{ fontWeight: 700, fontSize: 28, verticalAlign: 'middle', color: 'var(--text)', letterSpacing: 1 }}>EPCSPARK</span>
          </Col>
        </Row>
        {/* Tabs */}
        <Row>
          <Col xs={12}>
            <div className="profile-tabs mb-4 mt-2" style={{ display: 'flex', gap: 32, borderBottom: '1px solid rgba(255, 255, 255, 0.3)' }}>
              <button
                className="profile-tab-btn"
                onClick={() => navigate('/subscription')}
                type="button"
                style={{ fontWeight: 700, fontSize: '1.13rem', color: 'var(--text)', background: 'none', border: 'none', outline: 'none', padding: 0, margin: 0, position: 'relative', cursor: 'pointer' }}
              >
                Subscriptions
              </button>
              <button
                className="profile-tab-btn"
                onClick={() => navigate('/profile')}
                type="button"
                style={{ fontWeight: 700, fontSize: '1.13rem', color: 'var(--text)', background: 'none', border: 'none', outline: 'none', padding: 0, margin: 0, position: 'relative', cursor: 'pointer' }}
              >
                Profile
              </button>
              <button
                className="profile-tab-btn active"
                type="button"
                style={{ fontWeight: 700, fontSize: '1.13rem', color: 'var(--primary-500)', background: 'none', border: 'none', outline: 'none', padding: 0, margin: 0, position: 'relative', cursor: 'pointer' }}
              >
                Change Password
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h2
              style={{
                fontWeight: 700,
                fontSize: "2rem",
                color: "var(--text)",
                marginBottom: 24,
                textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                position: "relative",
                zIndex: 10,
              }}
            >
              Change Password
            </h2>
          </Col>
        </Row>
        {showSuccess && (
          <Alert variant="success" style={{ fontWeight: 600, fontSize: '1.1rem', textAlign: 'center' }}>
            ✅ You have successfully changed your password
          </Alert>
        )}
        <Form
          onSubmit={e => {
            e.preventDefault();
            const form = e.target;
            const current = form.elements['currentPassword'].value.trim();
            const newPass = form.elements['newPassword'].value.trim();
            const confirm = form.elements['confirmPassword'].value.trim();
            if (!current || !newPass || !confirm) {
              setShowSuccess(false);
              alert('All fields are required.');
              return;
            }
            setShowSuccess(true);
            setTimeout(() => setShowSuccess(false), 2500);
          }}
          style={{ marginTop: 8 }}
        >
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Current Password</Form.Label>
                <Form.Control name="currentPassword" type="password" placeholder="Enter Current Password" style={inputStyle} required />
              </Form.Group>
            </Col>
            <Col md={6}></Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>New Password</Form.Label>
                <Form.Control name="newPassword" type="password" placeholder="Enter New Password" style={inputStyle} required />
              </Form.Group>
            </Col>
            <Col md={6}></Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Confirm New Password</Form.Label>
                <Form.Control name="confirmPassword" type="password" placeholder="Confirm New Password" style={inputStyle} required />
              </Form.Group>
            </Col>
            <Col md={6}></Col>
            <Col xs={12} className="mt-2">
              <Button type="submit" style={{ width: 160, background: 'linear-gradient(135deg, #6d28d9 0%, #4f46e5 45%, #22d3ee 100%)', color: '#fff', fontWeight: 700, fontSize: '1.18rem', border: 'none', borderRadius: '12px', padding: '12px 0', margin: '10px 0 0 0', boxShadow: '0 4px 16px rgba(139, 92, 246, 0.25)', cursor: 'pointer', transition: 'all 0.3s ease' }}>
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
      <style>{`
        .profile-tab-btn.active {
          color: var(--primary-500) !important;
        }
        .profile-tab-btn.active::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -8px;
          width: 100%;
          height: 3px;
          background: var(--primary-500);
          border-radius: 2px;
        }
        .profile-tab-btn:not(.active):hover::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -8px;
          width: 100%;
          height: 3px;
          background: var(--primary-500);
          border-radius: 2px;
        }
        input::placeholder {
          color: var(--text-secondary) !important;
        }
        input:focus::placeholder {
          color: var(--text) !important;
        }
        h2 {
          color: var(--text) !important;
          text-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
        }
      `}</style>
    </div>
  );
}

const inputStyle = {
  background: "var(--surface-2)",
  border: "1px solid var(--border)",
  borderRadius: 8,
  fontSize: "1.08rem",
  fontWeight: 500,
  color: "var(--text)",
  padding: "14px 16px",
  marginBottom: 0,
  boxShadow: "none",
};

const labelStyle = {
  fontWeight: 700,
  color: "var(--text)",
  fontSize: "1.01rem",
  marginBottom: 6,
}; 